import { TABLEPAI } from "@/enums/pageEnum";
import {
  useMemo,
  useEffect,
  useState,
  useCallback,
  useTransition,
} from "react";
import { Flex, Button, Skeleton } from "antd";
import { useSize } from "ahooks";
import clsx from "clsx";
import { useAppSelector } from "@/store";
import { getSelectLists } from "@api";
import { TelemetryItem } from "@/facilities/model/user";

const MonitoringPanel = () => {
  const collaps = useAppSelector((state) => state.app.collaps);
  const monitPanel = useAppSelector(
    (state: { public: { monitPanel: Record<string, any> } }) =>
      state.public.monitPanel
  );
  const size = useSize(document.body);
  const [isPending, startTransition] = useTransition();
  const [rebCodes, setRebCodes] = useState<string[]>([]);
  const widthRows = useMemo(() => {
    if (!size) return 200;
    const w = collaps ? size?.width - 139 : size?.width - 290;
    return w / 11;
  }, [size, collaps]);

  const getDatas = useCallback(() => {
    startTransition(async () => {
      const res = await getSelectLists(TABLEPAI.RBE_CODE);
      setRebCodes(res.data.body);
    });
  }, []);

  useEffect(() => {
    getDatas();
  }, [getDatas]);
  return (
    <div className="bg-[#fff] dark:bg-[#141414] p-4 min-h-[calc(100vh-362px)]">
      {isPending ? (
        <Skeleton active />
      ) : (
        <Flex wrap>
          {rebCodes.map((item: string) => {
            const monItem = monitPanel.find(
              (li: TelemetryItem) => li.key === item
            );
            return (
              <div
                key={item}
                className={clsx("text-center text-[12px] flex items-center")}
              >
                <Button
                  style={{ width: `${widthRows}px` }}
                  disabled
                  datatype={monItem?.key}
                  className={clsx(
                    "!h-14 flex-1 !border-t-0 !border-l-0 border-[#C5C5C5] border-solid",
                    monItem?.value === "true" ? "rbeAotAtive" : ""
                  )}
                >
                  {item}
                </Button>
              </div>
            );
          })}
        </Flex>
      )}
    </div>
  );
};

export default MonitoringPanel;
